import React from "react";
import Typography from "@material-ui/core/Typography";
import ListaTags from "../components/ListaTags";
import {tagsEspejoMandatorioResources} from "../endpoints";

class Mandatorios extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            columnas: [
                { title: 'Tag', field: 'id'},
                { title: 'Estado', field: 'estado'}],
            tipo: 'espejos/mandatorios',
            idUbicacion: -1,
            tagsMandatorios: []
        }
    }

    consultarTagsEspejo= () =>{
        tagsEspejoMandatorioResources.getTagsEspejo().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({tagsMandatorios:result.tags_espejo})
            }
            else if (result.status_code === 401){
                this.setState({openSnack:true, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }


    refrescarTagsUbicacion=()=>{
        this.consultarTagsEspejo()
    }

    componentDidMount() {
        this.consultarTagsEspejo()
    }

    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>
                    Mandatorios
                </Typography>
                <ListaTags id_ubicacion={this.state.idUbicacion} datos={this.state.tagsMandatorios} columnas={this.state.columnas} tipo={this.state.tipo} refrescarTags={this.refrescarTagsUbicacion}/>
            </div>
        )
    }
}

export default Mandatorios;